var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-center"},[_c('v-select',{attrs:{"items":_vm.items,"label":"Enterprise"},model:{value:(_vm.enterprise),callback:function ($$v) {_vm.enterprise=$$v},expression:"enterprise"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }